import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, Volume2, VolumeX, Play, Pause } from 'lucide-react';
import { PROPERTY_IMAGES } from '../utils/constants';

const Hero = () => {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  // Actual Jalsa Retreat drone footage
  const heroVideo = 'https://customer-assets.emergentagent.com/job_78654d4f-b852-45dc-96c3-581267dc808a/artifacts/i95shcep_JALSA%20Display%20drone%20shots.mp4';

  const toggleMute = () => {
    setIsMuted(!isMuted);
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
    }
  };

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play().catch(() => {});
      }
    }
  };

  const scrollToContent = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <div className="relative h-screen w-full overflow-hidden bg-navy-900">
      {/* Full Screen Video Background - No Overlay */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        src={heroVideo}
        muted={isMuted}
        loop
        playsInline
        autoPlay
        poster={PROPERTY_IMAGES.jalsaRetreat.hero}
      />

      {/* Minimal Video Controls - Bottom Right */}
      <div className="absolute bottom-8 right-6 z-30 flex items-center space-x-3">
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={togglePlay}
          className="w-10 h-10 bg-black/30 backdrop-blur-sm hover:bg-gold-400 rounded-full flex items-center justify-center transition-all duration-300 group"
          aria-label={isPlaying ? "Pause video" : "Play video"}
        >
          {isPlaying ? (
            <Pause className="w-4 h-4 text-white group-hover:text-navy-900" />
          ) : (
            <Play className="w-4 h-4 text-white group-hover:text-navy-900 ml-0.5" />
          )}
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={toggleMute}
          className="w-10 h-10 bg-black/30 backdrop-blur-sm hover:bg-gold-400 rounded-full flex items-center justify-center transition-all duration-300 group"
          aria-label={isMuted ? "Unmute video" : "Mute video"}
        >
          {isMuted ? (
            <VolumeX className="w-4 h-4 text-white group-hover:text-navy-900" />
          ) : (
            <Volume2 className="w-4 h-4 text-white group-hover:text-navy-900" />
          )}
        </motion.button>
      </div>

      {/* Scroll Down Indicator - Bottom Center */}
      <motion.button
        onClick={scrollToContent}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-30 flex flex-col items-center text-white/80 hover:text-gold-400 transition-colors duration-300 cursor-pointer"
      >
        <span className="text-xs tracking-widest mb-2 font-light">SCROLL</span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          <ChevronDown className="w-6 h-6" />
        </motion.div>
      </motion.button>
    </div>
  );
};

export default Hero;
